import { compose } from 'recompose';
import { withSaveScrollElementNodeContext } from '../../../utils/hoc/withItemsLoader';
import { withLassoSelectedAreaStyle } from '../../common/Lasso/withLassoSelectedAreaStyle/withLassoSelectedAreaStyle';
import { IInner, IOuter } from '../types';

export const enhance = compose<IInner, IOuter>(withLassoSelectedAreaStyle, withSaveScrollElementNodeContext);
